import { z } from 'zod'
import { timestampSchema, uuidSchema } from './common.js'

/**
 * Output-Approval-Workflow (Migration 021, M3-A): Outputs aus _Outputs koennen
 * zur Review angemeldet (member+) und von owner/admin freigegeben oder
 * abgelehnt werden.
 */

export const outputApprovalStatusSchema = z.enum(['draft', 'pending_review', 'approved', 'rejected'])
export type OutputApprovalStatus = z.infer<typeof outputApprovalStatusSchema>

export const outputApprovalSchema = z.object({
  id: uuidSchema,
  workspace_id: uuidSchema,
  vault_file_path: z.string(),
  output_type: z.string(),
  status: outputApprovalStatusSchema,
  reviewer_user_id: uuidSchema.nullable(),
  comment: z.string().nullable(),
  created_at: timestampSchema,
  updated_at: timestampSchema,
})
export type OutputApproval = z.infer<typeof outputApprovalSchema>

/** POST /api/outputs/approval — Output zur Review anmelden (member+). */
export const outputApprovalRequestSchema = z.object({
  path: z.string().min(1).max(500),
  output_type: z.string().min(1).max(80),
})
export type OutputApprovalRequest = z.infer<typeof outputApprovalRequestSchema>

/** POST /api/outputs/approval/decide — Review-Entscheid (owner/admin).
 *  Ablehnung braucht eine Begruendung (Server-seitig erzwungen). */
export const outputApprovalDecisionSchema = z
  .object({
    path: z.string().min(1).max(500),
    decision: z.enum(['approved', 'rejected']),
    comment: z.string().max(2000).optional(),
  })
  .refine((value) => value.decision !== 'rejected' || (value.comment?.trim().length ?? 0) > 0, {
    message: 'Kommentar ist bei Ablehnung erforderlich',
    path: ['comment'],
  })
export type OutputApprovalDecision = z.infer<typeof outputApprovalDecisionSchema>
